module.exports = __webpack_public_path__ + "img/hanayik_taylor.56ce2866.png";